// extracted by mini-css-extract-plugin
export default {"CalculatorBody":"Calculator_CalculatorBody__z7eqe","displayContainer":"Calculator_displayContainer__lA+t6","buttonContainer":"Calculator_buttonContainer__-tfF2"};